import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';
import { cartTotal, totalSavings } from 'utils/fees';
import moment from 'moment';
import { bugsnagClient } from 'utils/bugsnag';

export function init() {
  if (window.GA_TRACKING_ID) {
    ReactGA.initialize(window.GA_TRACKING_ID);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  if (window.FB_PIXEL_ID) {
    ReactPixel.init(window.FB_PIXEL_ID);
  }

  if (window.TIKTOK_PIXEL_ID) {
    TiktokPixel.init(window.TIKTOK_PIXEL_ID);
  }
}

export function pageView(path) {
  if (window.GA_TRACKING_ID) {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  if (window.FB_PIXEL_ID) {
    ReactPixel.pageView();
  }

  if (window.TIKTOK_PIXEL_ID) {
    TiktokPixel.pageView();
  }

  if (path == '/checkout') {
    checkout();
  }
}

export function viewContent(description) {
  if (window.GTAG_TRACKING_ID) {
    gtag("event", "view_item", {
      items: [{item_name: description}]
    });
  }

  if (window.FB_PIXEL_ID) {
    ReactPixel.track('ViewContent', {description});
  }

  if (window.TIKTOK_PIXEL_ID) {
    TiktokPixel.track('ViewContent', {description});
  }
}

export function addToCart(params) {
  if (window.GTAG_TRACKING_ID) {
    gtag("event", "add_to_cart", {
      currency: params.currency,
      value: params.value,
      items: [{item_id: params.card_design_id}]
    });
  }

  if (window.FB_PIXEL_ID) {
    ReactPixel.track('AddToCart', {quantity: params.quantity, value: params.value, currency: params.currency});
  }

  if (window.TIKTOK_PIXEL_ID) {
    TiktokPixel.track('AddToCart', {quantity: params.quantity, value: params.value, currency: params.currency});
  }
}

export function checkout() {
  if (window.FB_PIXEL_ID) {
    ReactPixel.track('InitiateCheckout');
  }

  if (window.TIKTOK_PIXEL_ID) {
    TiktokPixel.track('InitiateCheckout');
  }
}

export function purchase(params) {
  if (window.GTAG_TRACKING_ID) {
    gtag("event", "purchase", {
      currency: params.currency,
      value: params.value,
      items: _.map(params.cart || [], (i) => { return { item_id: i.card_design_id } })
    });
  }

  if (window.FB_PIXEL_ID) {
    ReactPixel.track('Purchase', {value: params.value, currency: params.currency});
  }

  if (window.TIKTOK_PIXEL_ID) {
    TiktokPixel.track('PlaceAnOrder', {value: params.value, currency: params.currency});
  }
}

export function ensightenView(path, previousPath, cart, products, orderId) {
  if (!window.ENSIGHTEN_TRACKING_ID) {
    return;
  }

  try {
    var pathMap = ensightenPathMap(path)
    if (!pathMap) {
      return;
    }

    var page = {
      attributes: {
        page_referrer_url: previousPath ? window.location.origin + previousPath : document.referrer,
        page_referrer_page_name: ensightenPathMap(previousPath)?.name,
        page_hit_timestamp: Math.floor(new Date() / 1000)
      },
      pageinfo: {
        page_name: pathMap.name,
        page_url: window.location.href,
        page_url_domain: window.location.host,
        page_tag_group: pathMap.tag_group
      }
    }

    var basket = {
      basketinfo: {
        productinfo: ensightenCartMap(cart, products),
        paymentinfo: {
          payment_amount: cartTotal(cart).toFixed(2),
          payment_promotions_amount: totalSavings(cart).toFixed(2)
        }
      }
    }

    // Add product being viewed to productinfo array
    if (path.includes('card_designs')) {
      var slug = path.split("/").filter(item => item).pop();
      var product = _.find(products, function(c) { return c.slug == slug });

      basket['basketinfo']['productinfo'].push({
        product_id: product.id,
        product_name: product.name.toLowerCase()
      });
    }

    if (orderId) {
      basket['basketinfo']['agreementinfo'] = {
        agreement_outcome: 1,
        agreement_sale_id: orderId,
        agreement_fulfillment_date: moment(new Date()).format('DD-MM-YYYY')
      }
    }

    window.ensightenSubmit({page: page, basket: basket});
  } catch(error) {
    // Do nothing and notify Bugsnag
    try {
      if (window.BUGSNAG_API_KEY) {
        bugsnagClient.notify(error);
      }
    } catch {
      // Just in case
    }
  }

}

// Hacky little function to figure out data to send to Ensighten for Tesco
function ensightenPathMap(path) {
  if (!path) {
    return null;
  }

  if (path == '/') {
    return {name: 'tescogiftcards:giftcards:brochureware:homepage', tag_group: 'hp'};
  } else if (path.includes('card_designs')) {
    return {name: 'tescogiftcards:giftcards:brochureware:card-designs', tag_group: 'pa'};
  } else if (path.includes('categories')) {
    return {name: 'tescogiftcards:giftcards:brochureware:categories', tag_group: 'ph'};
  } else if (path.includes('collections')) {
    return {name: 'tescogiftcards:giftcards:brochureware:collections', tag_group: 'pl'};
  } else if (path.includes('balance')) {
    return {name: 'tescogiftcards:giftcards:brochureware:balance', tag_group: 'bc'};
  } else if (path.includes('cart')) {
    return {name: 'tescogiftcards:giftcards:application:cart', tag_group: 'bk'};
  } else if (path.includes('checkout')) {
    return {name: 'tescogiftcards:giftcards:application:checkout', tag_group: 'py'};
  } else if (path == '/thanks') {
    return {name: 'tescogiftcards:giftcards:application:complete', tag_group: 'cp'};
  } else if (path.includes('faqs')) {
    return {name: 'tescogiftcards:giftcards:brochureware:faqs', tag_group: ''};
  } else if (path.includes('privacy')) {
    return {name: 'tescogiftcards:giftcards:brochureware:privacy', tag_group: ''};
  } else if (path.includes('terms_conditions')) {
    return {name: 'tescogiftcards:giftcards:brochureware:terms-conditions', tag_group: ''};
  } else if (path.includes('contact_us')) {
    return {name: 'tescogiftcards:giftcards:brochureware:contact-us', tag_group: ''};
  }

  return null;
}

function ensightenCartMap(cart, products) {
  return _.map(cart, (i) => {
    return {
      product_id: i.card_design_id,
      product_name: _.find(products, function(c) { return c.id == i.card_design_id }).name.toLowerCase(),
      product_price: parseFloat(i.amount).toFixed(2),
      product_quantity: i.quantity
    };
  });
}
